module.exports = __webpack_public_path__ + "static/media/home-animated-image.c8eb422e.svg";